import { render, staticRenderFns } from "./BookingsList.vue?vue&type=template&id=65e9624c&scoped=true&"
import script from "./BookingsList.vue?vue&type=script&lang=js&"
export * from "./BookingsList.vue?vue&type=script&lang=js&"
import style0 from "./BookingsList.vue?vue&type=style&index=0&id=65e9624c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e9624c",
  null
  
)

export default component.exports